// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

// The tagged union or sum type for the algebraic type `AchievementType`.
const AchievementType = __t.enum("AchievementType", {FirstWin: __t.unit(),
  GettingStarted: __t.unit(),
  DedicatedPlayer: __t.unit(),
  Winner: __t.unit(),
  ProSweeper: __t.unit(),
  AccountClaimed: __t.unit(),
  SpeedDemon: __t.unit(),
  IntermediateAce: __t.unit(),
  ExpertElite: __t.unit(),
  LightningFingers: __t.unit(),
  PerfectGame: __t.unit(),
  Centurion: __t.unit(),
  Veteran: __t.unit(),
  Legend: __t.unit(),
  Marathon: __t.unit(),
  Unstoppable: __t.unit(),
  HotStreak: __t.unit(),
  OnFire: __t.unit(),
  BeginnerMaster: __t.unit(),
  IntermediateMaster: __t.unit(),
  ExpertMaster: __t.unit(),
  AllRounder: __t.unit(),
  TeamPlayer: __t.unit(),
  RaceVictor: __t.unit(),
  TacticalGenius: __t.unit(),
  RankedDebut: __t.unit(),
  RankedClimber: __t.unit(),
  RankedElite: __t.unit(),
});

export default AchievementType;


